<template>
  <el-dialog title="提示" @closed="closeDialog" :visible.sync="templeShowDialog" width="30%">
    <span>{{ message }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="sure" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    name: 'DeleteSureDialog',
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      message: {
        type: String,
        default: '',
      },
    },
    watch: {
      showDialog(var1, var2) {
        console.log(var1, var2);
        this.templeShowDialog = var1;
      },
    },
    data() {
      return {
        templeShowDialog: this.showDialog,
        loading: false,
      };
    },
    methods: {
      sure() {
        this.$emit('sure');
        this.loading = true;
      },
      closeDialog() {
        this.$emit('closeDialog', false);
        this.loading = false;
      },
    },
  };
</script>
